"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _index = require("../../material/index");

var _ = _interopRequireDefault(require("./403/403"));

var _2 = _interopRequireDefault(require("./404/404"));

var _3 = _interopRequireDefault(require("./500/500"));

var _permission = _interopRequireDefault(require("./permission/permission"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// pages

/* ========== ~~~~~~~~~~ PAGE : ERROR ~~~~~~~~~~ ========== */


var _default = function _default(props) {
  return _react.default.createElement(_index.Division, {
    name: "error"
  }, _react.default.createElement(_index.Body, null, _react.default.createElement(_reactRouter.Switch, null, _react.default.createElement(_reactRouter.Route, {
    path: "/error/500",
    component: _3.default
  }), _react.default.createElement(_reactRouter.Route, {
    path: "/error/404",
    component: _2.default
  }), _react.default.createElement(_reactRouter.Route, {
    path: "/error/403/:home?",
    component: _.default
  }), _react.default.createElement(_reactRouter.Route, {
    path: "/error/permission",
    component: _permission.default
  }))), _react.default.createElement(_index.Footer, null));
};

exports.default = _default;